export const DESKTOP_NAVBAR_TOP_PADDING_PX = 14;
export const DESKTOP_NAVBAR_CONTENT_HEIGHT_PX = 59.481;
export const DESKTOP_NAVBAR_MEGA_MENU_TOP_PX =
  DESKTOP_NAVBAR_TOP_PADDING_PX + DESKTOP_NAVBAR_CONTENT_HEIGHT_PX;
